import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../../../Styles";
import { NewInput, CheckBox, CheckStyles } from "../..";
import { DataObj, getDataLevelFromKey, getLabelFromKey, ReportTemplate } from "../../../Definitions/valueTypes";

interface Lvl1_Props {
  templateData?: ReportTemplate
  onTemplateDataChange: (data: ReportTemplate) => void
}

export default function TemplateModalLvl1({ templateData, onTemplateDataChange}:Lvl1_Props) {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 690px)`);
  
  // Template Name
  const _templateName = useMemo(() => { return templateData && templateData.name ? templateData.name : undefined}, [templateData])
  
  // Data Levels
  const dataLevels = useMemo(() => {
    const _dataLevels: DataObj[] = [
      "animal_number",
      "animal_group_id",
      "system_id"
    ]

    return _dataLevels.map((param, index) => {
      const label = getLabelFromKey(param); 

      return (
        <CheckBox 
          key={index} 
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue} 
          isChecked={templateData && templateData.dataLevel === getDataLevelFromKey(param)}
          onChange={() => onTemplateDataChange({ ...templateData, templateId: templateData?.templateId || 0, dataLevel: getDataLevelFromKey(param) })}
        />
      )
    })

  }, [onTemplateDataChange, t, templateData])

  return (
    <div style={{ width: "100%", margin: "20px 0px 0px 0px" }}>
      <div style={{padding: "10px"}}>
        <NewInput
          header={t("reportPages.reports.templateName", {defaultValue: "Template Name"})}
          onChange={(value) => onTemplateDataChange({...templateData, templateId: templateData?.templateId || 0, name: value})}
          valueOverrides={{ defaultValue: _templateName }}
        />
      </div>
      <div style={{ borderTop: "2px solid " + colors.blueDarkSecondary, borderBottom: "2px solid " + colors.blueDarkSecondary, padding: "10px 0px", maxHeight: "200px", display: "flex", alignItems: "start", justifyContent: "center", flexDirection: "column", gap: "10px" }}>
        <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 0px 22px" }}>{t("reportPages.reports.dataLevel", { defaultValue: "data level" })}</p>
        <div style={{width: "fit-content", display: "flex", flexWrap: "wrap", columnGap: "60px", rowGap: "10px", margin: "0 auto", flexDirection: mobileXs ? "column" : "row"}}>
          {dataLevels}
        </div>
      </div>
    </div>
  )
}